import { Component, EventEmitter, forwardRef, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'acan-switch',
  templateUrl: './acan-switch.component.html',
  styleUrls: ['./acan-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AcanSwitchComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AcanSwitchComponent implements ControlValueAccessor {
  @HostBinding('class') hostClass = 'acan-switch';

  @Input() inputId = '';
  @Input() disabled = false;

  /** PrimeNG-compatible change event (`checked` mirrors p-inputSwitch). */
  @Output() onChange = new EventEmitter<{ checked: boolean }>();

  value = false;

  private propagateChange: (value: boolean) => void = () => {};
  private propagateTouched: () => void = () => {};

  writeValue(value: boolean | null): void {
    this.value = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.propagateTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: boolean): void {
    this.value = value;
    this.propagateChange(value);
    this.onChange.emit({ checked: value });
  }

  onBlur(): void {
    this.propagateTouched();
  }
}
